declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

// Matches the `open_video_url` event jtj-app sends via Firebase Analytics, so
// web and app watches can be reported together. Named for what it actually
// does — hand off to youtube.com — since nothing plays in place.
function trackOpen(link: HTMLElement) {
  window.gtag?.('event', 'open_video_url', {
    entry: link.getAttribute('data-video-entry'),
    title: link.getAttribute('data-video-title'),
  })
}

// YouTube doesn't serve every thumbnail size for every video, and the CDN can
// fail outright. Rather than leave a broken image in the layout, drop back to
// the play button on a flat background.
function handleBrokenThumbnail(link: HTMLElement) {
  const img = link.querySelector<HTMLImageElement>('.devo-video__thumbnail')
  if (!img) { return }

  const markBroken = () => link.classList.add('devo-video__link--no-thumbnail')

  if (img.complete && img.naturalWidth === 0) {
    markBroken()
  } else {
    img.addEventListener('error', markBroken, { once: true })
  }
}

export function devoVideoInit() {
  document.querySelectorAll<HTMLElement>('[data-video-cta]').forEach((link) => {
    handleBrokenThumbnail(link)

    link.addEventListener('click', () => trackOpen(link))
  })
}
